module.exports = __webpack_public_path__ + "/e4484894ae96cf362861bb444cdfc148.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/evernote_logo_white.svg
 ** module id = 850
 ** module chunks = 0
 **/